import dayjs from 'dayjs';
import { initializeInactivityTimerWithDefaultOptions } from './common/inactivity-timer';

const now = dayjs();

$(() => {
	initializeInactivityTimerWithDefaultOptions(now);
});
